export default __webpack_public_path__ + "static/win-lose-opportunity-bac24f073129b624e3fc0f9af2ec5f8e.mp4";